import { UserMngItem } from '@/types/userMng';
import { Form, Input, Modal } from 'antd';
import { useEffect } from 'react';

export type DeAlertConfirmDialogType = 'batch' | 'single';

interface DeAlertConfirmDialogProps {
  type?: DeAlertConfirmDialogType;
  user?: UserMngItem;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (values: { deAlertReason: string }) => void;
}

const DeAlertConfirmDialog = ({
  type,
  user,
  isOpen,
  onClose,
  onConfirm,
}: DeAlertConfirmDialogProps) => {
  const [deAlertForm] = Form.useForm<{
    deAlertReason: string;
  }>();

  const handleOk = () => {
    const values = deAlertForm.getFieldsValue();
    onConfirm(values);
  };

  useEffect(() => {
    deAlertForm.resetFields();
  }, [isOpen, deAlertForm]);

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title={
        type === 'single'
          ? `确认解除警告 用户: ${user?.name}?`
          : '确定批量解除警告?'
      }
      okButtonProps={{
        type: 'primary',
        htmlType: 'submit',
      }}
      destroyOnClose
      modalRender={(node) => (
        <Form layout="vertical" form={deAlertForm} onFinish={handleOk}>
          {node}
        </Form>
      )}
    >
      <div>
        <Form.Item
          label="解封理由"
          name="deAlertReason"
          required
          rules={[{ required: true, message: '请输入解封理由' }]}
        >
          <Input.TextArea rows={4} maxLength={200} />
        </Form.Item>
      </div>
    </Modal>
  );
};

export default DeAlertConfirmDialog;
